import { AppSidebar } from "@/components/AppSidebar";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import OnboardingTour from "@/components/onboarding/OnboardingTour";
import TrialModeBanner from "@/components/trial/TrialModeBanner";

export default function AppLayout() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/dpadmin" replace />;
  }

  return (
    <SidebarProvider defaultOpen>
      <div className="flex min-h-screen w-full bg-background">
        <AppSidebar />
        <SidebarInset className="min-w-0">
          <ImpersonationBanner />
          <TrialModeBanner />
          <OnboardingTour />
          <div className="fixed bottom-4 left-4 z-50 md:hidden">
            <SidebarTrigger className="h-10 w-10 rounded-full border border-border bg-background shadow-editorial" />
          </div>
          <Outlet />
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
